<template>
    <a-modal title="个人基本信息"
             :width="550"
             :visible="visible"
             @cancel="$emit('cancel')"
             @ok="confirmPassword"
             :maskClosable="false"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <a-form :form="form">
            <table style="width:100%" class="fx-form">
                <tr>
                    <th class="not-null">账号：</th>
                    <td>
                        <a-form-item>
                            <a-input
                                    v-decorator="['account', {initialValue:account.account ,rules: [{ required: true, message: '账号不能为空' },{validator: fixedAccount}]}]"
                            />
                        </a-form-item>
                    </td>
                </tr>
                <tr>
                    <th class="not-null">真实姓名：</th>
                    <td>
                        <a-form-item>
                            <a-input
                                    v-decorator="['nickname', {initialValue:account.nickname ,rules: [{ required: true, message: '昵称不能为空' }]}]"
                            />
                        </a-form-item>
                    </td>
                </tr>
                <tr>
                    <th class="not-null">邮箱：</th>
                    <td>
                        <a-form-item>
                            <a-input
                                    v-decorator="['email',{initialValue:account.email ,rules: [{ required: true, message: '邮箱不能为空'},{type:'email',message: '请输入有效的邮箱'}]}]"
                            />
                        </a-form-item>
                    </td>
                </tr>
                <tr>
                    <th class="not-null">身份证号码：</th>
                    <td>
                        <a-form-item>
                            <a-input
                                    v-decorator="['cardId', {initialValue:account.cardId ,rules: [{ required: true, message: '身份证号码不能为空' }]}]"
                            />
                        </a-form-item>
                    </td>
                </tr>
                <tr>
                    <th class="not-null">手机号：</th>
                    <td>
                        <a-form-item>
                            <a-input
                                    v-decorator="['phone',{initialValue:account.phone ,rules: [{type: 'string',message: '输入正确的格式', required: true, pattern: /[1][3,4,5,7,8,9][0-9]{9}/ }]}]"
                            />
                        </a-form-item>
                    </td>
                </tr>
                <tr>
                    <th class="not-null">旧密码：</th>
                    <td>
                        <a-form-item>
                            <a-input type="password"
                                    v-decorator="['oldPassword', {rules: [{required: true, message: '旧不能为空' }]}]"/>
                        </a-form-item>
                    </td>
                </tr>
                <tr>
                    <th class="not-null">密码：</th>
                    <td>
                        <a-form-item>
                            <a-input type="password"
                                    v-decorator="['password', {rules: [{required: true, message: '密码不能为空' }]}]"/>
                        </a-form-item>
                    </td>
                </tr>
                <tr>
                    <th class="not-null">确认密码：</th>
                    <td>
                        <a-form-item>
                            <a-input type="password"
                                    v-decorator="['password2', {rules: [{ required: true, message: '确认密码不能为空' }]}]"
                            />
                        </a-form-item>
                    </td>
                </tr>
            </table>
        </a-form>
    </a-modal>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'

    export default {
        created() {
            this.userName = this.$store.getters.nickname
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                form: this.$form.createForm(this),
                userName: '',
                orgName: '',
                actions: [
                    {type: 'bank', text: '广东省环境监测中心'},
                    {type: 'clock-circle', text: '发布时间：今天10: 30 '},
                ],
                dealData: [],
                todayData: [],
                historyData: [],
                queryParam: {},
                id: this.$route.query.id,
                modalLoading: false,
                params: {},
                loading: false,
                account: ''
            }
        },
        methods: {
            initInfo(id) {
                let that = this
                this.$http.get('/api/v1/supplier/account/get_account_info.json?id='+id).then(function (res) {
                    that.account = res.result.account
                })
            },
            onSubmit() {
                let params = {...this.form.getFieldsValue()}
                if (params.oldPassword !== null || params.oldPassword !== '') {
                    if (params.password === '' || params.password === null) {
                        this.$message.error("密码不能为空")
                        return;
                    }
                    if (params.password !== params.password2) {
                        this.$message.error('确认密码不一致!');
                        return;
                    }
                }

                let that = this
                params.id = this.account.id
                params.accountType = '2'
                this.form.validateFields((err, values) => {
                    if (err) {
                        return
                    }
                    this.modalLoading = true
                    this.$http.post("/api/v1/supplier/account/edit_account.json", qs.stringify(params, {allowDots: true})).then(function (res) {
                        if (res.code === 200) {
                            that.$message.success("添加成功!")
                            that.modalLoading = false
                            that.$emit('success')
                            that.$router.go(0)
                        }
                    })
                })
            },
            confirmPassword () {
                let params = { ...this.form.getFieldsValue() }
                params.id = this.account.id
                let params2 = {}
                params2.password = params.oldPassword
                params2.id = params.id
                // return
                let that = this
                this.$http.post("/api/v1/supplier/account/confirm_password.json",qs.stringify(params2, { allowDots: true })).then(function (res) {
                    if (res.result === true){
                        that.onSubmit()
                    }else {
                        that.$message.error('旧密码不正确!')
                    }
                })
            },
            fixedAccount(rule, value, callback) {
                let params = {...this.form.getFieldsValue()}
                let params2 = {}
                params2.account = params.account
                // params2.id = this.account.id
                let that = this
                this.$http.post('/api/v1/supplier/account/validateAccount2.json',qs.stringify(params2, {allowDots: true})).then(function (res) {
                    if (res.result.length > 0) {
                        for (let i = 0; i < res.result.length; i++) {
                            if(res.result[i].id !== that.account.id) {
                                callback('该账号已存在');
                            }
                        }
                    }
                    callback();
                });

            }
        }
    };
</script>
<style lang="less" scoped>
    .fx-form th{
        width: 100px;
    }
</style>
